import nprogress from 'nprogress'

export const startProgress = () => nprogress.start()
export const stopProgress = () => nprogress.done()